// Validates that file names don't contain unsupported characters
// Allowed: letters, numbers, spaces, dots, hyphens, underscores, parentheses
// Not allowed: special characters like: \ / : * ? " < > | # % & { } $ ! ' @ + ` = etc.

const INVALID_FILENAME_CHARS = /[\\/:*?"<>|#%&{}$!'@+`=[\]^~;]/

export default {
    getMessage(field, args) {
        return field
    },
    validate(value, args) {
        // If no file is provided, validation passes (use 'required' rule for that)
        if (!value || !value.name) return true

        const fileName = value.name

        // Check for invalid characters
        if (INVALID_FILENAME_CHARS.test(fileName)) {
            return false
        }

        return true
    }
}
